export default {
  apiUrl: 'https://lkpol-api.cenango.com/api/v1'
};
